module.exports = __webpack_public_path__ + "img/adult.8f870524.svg";